export const PROFILE_ROLES_LIST = [
  {
    id: 1,
    label: "Super Admin",
    value: "SuperAdmin",
    name: "role",
    roleLevel: 1,
  },
  {
    id: 2,
    label: "Manufacturer",
    value: "Manufacturer",
    name: "role",
    roleLevel: 2,
  },
  {
    id: 3,
    label: "Organization Admin",
    value: "OrgAdmin",
    name: "role",
    roleLevel: 3,
  },
  {
    id: 4,
    label: "Distributer",
    value: "Distributer",
    name: "role",
    roleLevel: 4,
  },
  {
    id: 5,
    label: "Dealer",
    value: "Dealer",
    name: "role",
    roleLevel: 5,
  },
  {
    id: 6,
    label: "Sub-Dealer",
    value: "Sub_Dealer",
    name: "role",
    roleLevel: 6,
  },
  {
    id: 7,
    label: "Retailer",
    value: "Retailer",
    name: "role",
    roleLevel: 7,
  },
  {
    id: 8,
    label: "Customer",
    value: "EndUser",
    name: "role",
    roleLevel: 8
  },

  {
    id: 9,
    label: "Technician",
    value: "Technician",
    name: "role",
    roleLevel: 9
  },
];

export const PROFILE_ROLES_LEVEL = {
  SuperAdmin: 1,
  Manufacturer: 2,
  OrgAdmin: 3,
  Distributer: 4,
  Dealer: 5,
  Sub_Dealer: 6,
  Retailer: 7,
  EndUser: 8,
  Technician: 9
};

export const SUPER_ADMIN = "SuperAdmin";
export const ORGANIZATION_ADMIN = "OrgAdmin";
export const DEALER = "Dealer";
export const SUB_DEALER = "Sub_Dealer";
export const DISTRIBUTER = "Distributer";
export const RETAILER = "Retailer";
export const CUSTOMER = "EndUser";
export const TECHNICIAN = "Technician";
export const MANUFACTURER = "Manufacturer";

export const ROLE_PERMISSION_ORG_ADMIN = [
  { label: 'Distributer', value: 'dst' },
  { label: 'Dealer', value: 'dlr' },
  { label: 'Sub-Dealer', value: 'sdlr' },
  { label: 'Retailer', value: 'rtr' },
]
